import { render, staticRenderFns } from "./kartfavorites.vue?vue&type=template&id=149489fb&scoped=true&"
import script from "./kartfavorites.vue?vue&type=script&lang=js&"
export * from "./kartfavorites.vue?vue&type=script&lang=js&"
import style0 from "./kartfavorites.vue?vue&type=style&index=0&id=149489fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149489fb",
  null
  
)

export default component.exports